import {AvailablePropertiesContext} from "components/src/context/AvailablePropertiesContextProvider";
import {useContext} from 'react'

export function useAvailablePropertiesContext()
{
    const context = useContext(AvailablePropertiesContext);

    if (!context) {
        throw new Error(
            "useAvailablePropertiesContext must be used within the scope of AvailablePropertiesContextProvider"
        );
    }

    return context;
}